<template>
  <el-container class="father">
    <!-- 左侧菜单栏 -->
    <el-aside>
      <el-menu
        router
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        :default-openeds="openeds"
        unique-opened
      >
        <el-submenu :index="item.path + ''" v-for="(item, index) in menuList" :key="index">
          <template slot="title">
            <!-- 一级菜单图标 -->
            <i :class="item.icon"></i>
            <span>{{ item.title }}</span>
          </template>
          <el-menu-item-group v-if="item.children.length > 0">
            <el-menu-item
              :index="k.path"
              v-for="(k, v) in item.children"
              :key="v"
              @click="cc(k)"
            >
              <!-- 子菜单图标 -->
              <i :class="k.icon" style="margin-right: 6px"></i>
              {{ k.title }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-aside>

    <!-- 右侧内容区域 -->
    <el-main class="main">
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'operation',
  components: {},
  data() {
    return {
      menuList: [
        {
          title: '调度中心',
          path: '/operation/dispatch',
          icon: 'el-icon-s-data', // 👈 一级菜单图标
          children: [
            {
              title: '订单调度',
              path: '/operation/dispatch/orderScheduling',
              icon: 'el-icon-s-order' // 👈 子菜单图标
            },
            {
              title: '历史调度',
              path: '/operation/dispatch/history',
              icon: 'el-icon-time' // 👈 子菜单图标
            }
          ]
        }
      ],
      openeds: ['/operation/dispatch'], // 👈 自动展开
      falg: true
    }
  },
  watch: {
    // 路由切换自动展开菜单
    '$route'(to) {
      this.openeds = ["/operation/dispatch"]
    }
  },
  mounted() {
    // 页面加载自动展开
    this.openeds = ["/operation/dispatch"]
  },
  methods: {
    handleOpen(index, indexPath) {
      this.falg = true
      if (this.$route.path === index) return
      this.$router.replace(index)
    },
    handleClose(index, indexPath) {},
    cc(e) {}
  }
}
</script>

<style lang="less" scoped>
.father {
  height: 100%;
  width: 100%;
  margin: 0;

  .el-aside {
    height: 100%;
    width: 220px !important;
    .el-menu {
      width: 100%;
      height: 100%;
    }
  }

  .main {
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
  }
}
</style>